import { Uid, ObjectWithUid } from "../utils.tsx";
import { ResponseWrapper, trackerPost, trackerPatch, trackerDelete, decodeResult } from "./basicApi.ts";
import { ParameterDto } from "./parameter.ts";


interface ParameterSettingsDto extends ObjectWithUid {
  id_parameter: Uid;
  slug_scan_type: string;
  // If no default is provided the default is assumed to be "".
  default?: string;
  read_only: boolean;
  // If a non-blank value is mandatory for this parameter
  required: boolean;
}

interface ParameterSettingsDetailsDto extends ObjectWithUid {
  parameter: ParameterDto;
  // If no default is provided the default is assumed to be "".
  default?: string;
  read_only: boolean;
  // If a non-blank value is mandatory for this parameter
  required: boolean;
}

interface ParameterSettingsCreateDto {
  id_parameter: Uid;
  slug_scan_type: string;
  default?: string;
  read_only?: boolean;
  required?: boolean;
}

interface ParameterSettingsUpdateDto extends ObjectWithUid {
  id_parameter: Uid;
  slug_scan_type: string;
  default?: string;
  read_only?: boolean;
  required?: boolean;
}


// Create a ParameterSettings record on the server
async function createParameterSettings(dto: ParameterSettingsCreateDto): Promise<ResponseWrapper<ParameterSettingsDto>> {
  const result = await trackerPost(`parameter_settings/`, JSON.stringify(dto));
  return decodeResult(result);
}


// Update a ParameterSettings record on the server
async function updateParameterSettings(dto: ParameterSettingsUpdateDto): Promise<ResponseWrapper<ParameterSettingsDto>> {
  const result = await trackerPatch(`parameter_settings/${dto.id}/`, JSON.stringify(dto));
  return decodeResult(result);
}


// Delete a ParameterSettings record from the server, returning the Id used if successful.
async function deleteParameterSettings(id: Uid): Promise<ResponseWrapper<Uid>> {
  const result = await trackerDelete(`parameter_settings/${id}/`, {});
 if (result.success) {
   return { success: true, response: id };
 }
 return { success: false, message: result.message };
}


export type { ParameterSettingsDto, ParameterSettingsDetailsDto, ParameterSettingsCreateDto };
export { createParameterSettings, updateParameterSettings, deleteParameterSettings }
